export const environment = {
  production: true,
  mssLibConfig: {
    applicationName: 'ClubHub',
  },
};
